import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const TheDifferenceContainer = styled('div', {
  backgroundColor: '$tertiary-200',
  color: '$accent-black',
  padding: '$8 $2 70px',

  '@bp2': {
    padding: '$10 $8',
  },

  '@bp3': {
    padding: '$12 $8',
  },
})

export const HeaderWrap = styled('div', {
  maxWidth: '1100px',
  mx: 'auto',
})

export const SectionHeader = styled('h1', {
  margin: 0,
  textAlign: 'center',
  color: '$accent-black',
  fontFamily: '$display',
  letterSpacing: '$tight',
  fontSize: '$h3',
  lineHeight: '$h3',
  marginBottom: '36px',

  '@bp2': {
    fontSize: '$h1',
    lineHeight: '$h1',
    letterSpacing: '$tight',
  },
})

export const DescriptionWrap = styled('div', {
  maxWidth: '820px',
  marginBottom: '42px',
  mx: 'auto',
  '@bp2': { mt: '$5' },
})

export const ContentWrap = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '32px',
  maxWidth: '1100px',
  width: '100%',
  mx: 'auto',

  '@bp2': {
    flexDirection: 'row',
    gap: '32px',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
})

export const ImageContainer = styled('div', {
  position: 'relative',
  width: '100%',
  borderRadius: '8px',
  aspectRatio: '361/430',
  maxWidth: '500px',
  margin: 'auto',

  '@bp2': {
    aspectRatio: 'unset',
    width: '472px',
    height: '542px',
    maxWidth: 'none',
    margin: 'unset',
  },
})

export const ClaimsContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',

  '@bp2': {
    height: '542px',
    width: '473px',
  }
})

export const ClaimBlock = styled('article', {})

export const ClaimTitle = styled('p', {
  margin: 0,
  textTransform: 'uppercase',
  fontWeight: '$semiBold',
  color: '$accent-black',
  fontSize: '$body',
  letterSpacing: '1.12px',
  lineHeight: '$body',
  marginBottom: '8px',
})

export const ClaimBody = styled(Text, {})

